module.exports = __webpack_public_path__ + "img/ipad-icon.ded120c5.svg";